import { render, staticRenderFns } from "./forgetPassChange.vue?vue&type=template&id=1ffa7c26&scoped=true"
import script from "./forgetPassChange.vue?vue&type=script&lang=js"
export * from "./forgetPassChange.vue?vue&type=script&lang=js"
import style0 from "./forgetPassChange.vue?vue&type=style&index=0&id=1ffa7c26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa7c26",
  null
  
)

export default component.exports